import EventEmitter from 'events'
import SocketService from './SocketService.js'
import { createPromise } from './utils.js'

class Platform extends EventEmitter {
  constructor () {
    super()
    SocketService.on('danmaku.platform.action', action => {
      this.emit('action', action)
    })
    SocketService.on('danmaku.platform.updateRoomList', roomList => {
      this.emit('updateRoomList', roomList)
    })
  }

  getRoomList () {
    return createPromise({
      event: 'danmaku.platform.getRoomList'
    })
  }

  checkUserLogin () {
    return createPromise({
      event: 'danmaku.platform.checkUserLogin'
    })
  }

  requestAPI (api, ...args) {
    if (!api) {
      return Promise.reject(new Error('参数错误'))
    } else {
      return createPromise({
        event: 'danmaku.platform.api.request',
        data: {
          api,
          args
        }
      })
    }
  }
}

export default new Platform()



// WEBPACK FOOTER //
// ./src/container/Platform.js